// Code review - In Progress
// Documentation - In Progress
import React, { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import MultiSelect from "../ReusableComponents/MultiSelect";
import { BindAPI } from "../services/APIConnection";

const PartnerMappingPopup = ({ data }) => {
  // Bind Dropdown Values
  const [bindCompanyDatas, setCompanyDatas] = useState([]);
  const [bindChainPartnerDatas, setChainPartnerDatas] = useState([]);

  // Selected Dropdown Values

  const [partnerMappingFields, setPartnerMappingFields] = useState({
    company: [],
    valueChainPartner: [],
    date: "",
  });

  const customerChange = (updatedOptions) => {
    const selectedItems = bindChainPartnerDatas.filter((item) =>
      updatedOptions.includes(item.value)
    );

    setPartnerMappingFields((prevFields) => ({
      ...prevFields,
      valueChainPartner: selectedItems,
    }));
  };

  const customerChange1 = (updatedOptions) => {
    const selectedItems = bindCompanyDatas.filter((item) =>
      updatedOptions.includes(item.value)
    );
    setPartnerMappingFields((prevFields) => ({
      ...prevFields,
      company: selectedItems,
    }));
  };
  useEffect(() => {
    const BindCompanyAndChainPartnerDropdown = async () => {
      const bindReferredBydatadrp = await BindAPI("PartnerAPI/BindPartner");
      const filteredData = bindReferredBydatadrp.data.Table;
      const filteredWithInActivatedByNull = filteredData.filter(
        (item) => item.Status === "Inactive"
      );
      const filteredWithTypeC = filteredData.filter(
        (item) => item.Type === "C"
      );
      const filteredWithTypeVCP = filteredData.filter(
        (item) => item.Type === "VCP"
      );

      bindCompanyData(filteredWithTypeC);
      bindChainPartnerData(filteredWithTypeVCP);
    };
    BindCompanyAndChainPartnerDropdown();
  }, []);

  const bindCompanyData = async (resultdata) => {
    try {
      if (resultdata.length > 0) {
        const CompanyAndChainPartnerDD = resultdata.map((m) => ({
          value: m.MstPartnerId,
          label: `${m.PartnerName} ${m.Type}`,
        }));
        setCompanyDatas(CompanyAndChainPartnerDD);
      } else {
        setCompanyDatas([]);
      }
    } catch (error) {
      console.error("Error fetching CompanyAndChainPartner data:", error);
    }
  };
  const bindChainPartnerData = async (resultdata) => {
    try {
      if (resultdata.length > 0) {
        const CompanyAndChainPartnerDD = resultdata.map((m) => ({
          value: m.MstPartnerId,
          label: `${m.PartnerName} ${m.Type}`,
        }));
        setChainPartnerDatas(CompanyAndChainPartnerDD);
      } else {
        setChainPartnerDatas([]);
      }
    } catch (error) {
      console.error("Error fetching CompanyAndChainPartner data:", error);
    }
  };

  useEffect(() => {
    if (!data || !data.MstCompanyId || !data.MstValueChainPartnerIds) return;

    const matchedCompany = bindCompanyDatas.find(
      (item) => item.value === data.MstCompanyId
    );

    const valueChainPartnerIds = data.MstValueChainPartnerIds.split(",");
    const matchedValueChainPartners = bindChainPartnerDatas.filter((item) =>
      valueChainPartnerIds.includes(String(item.value))
    );

    setPartnerMappingFields((prevFields) => ({
      ...prevFields,
      company: matchedCompany ? [matchedCompany] : [],
      valueChainPartner: matchedValueChainPartners || [],
    }));
  }, [data]);

  return (
    <div class="w-full">
      <div class={mainTable.mainContentScreen}>
        <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit">
          <div class="grid gap-4 mb-2 md:grid-cols-2">
            <div>
              <MultiSelect
                classStar="text-red-500"
                label="Company"
                filteredOptions={bindCompanyDatas}
                classFilterLabel="p-1 flex gap-1"
                class="custom-class"
                placeholder={
                  partnerMappingFields.company?.length > 0
                    ? "More Selected"
                    : "Select..."
                }
                name="ServiceSubCategory"
                selectedOptions={
                  partnerMappingFields.company
                    ? partnerMappingFields.company.map((item) => item.value)
                    : ""
                }
                disabled={true}
                dropDownDisabled={true}
                classDiv="relative w-full inline-block"
                onChange={customerChange1}
                classLabel={mainTable.labelNoWrap}
              />

              {partnerMappingFields.company?.length > 0 && (
                <div className="mt-2">
                  <div className="flex flex-col gap-2">
                    {partnerMappingFields.company.map((item, index) => (
                      <span
                        key={index}
                        className="bg-gray-100 px-2 py-1 w-fit rounded text-sm text-gray-800"
                      >
                        {item.label}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div>
              <MultiSelect
                classStar="text-red-500"
                label="Value Chain Partner"
                filteredOptions={bindChainPartnerDatas}
                classFilterLabel="p-1 flex gap-1"
                class="custom-class"
                placeholder={
                  partnerMappingFields.valueChainPartner?.length > 0
                    ? "More Selected"
                    : "Select..."
                }
                disabled={true}
                dropDownDisabled={true}
                name="valueChainPartner"
                selectedOptions={
                  partnerMappingFields.valueChainPartner
                    ? partnerMappingFields.valueChainPartner.map(
                        (item) => item.value
                      )
                    : ""
                }
                classDiv="relative w-full inline-block"
                onChange={customerChange}
                classLabel={mainTable.labelNoWrap}
              />

              {partnerMappingFields?.valueChainPartner?.length > 0 && (
                <div className="mt-2">
                  <div className="flex flex-col gap-2">
                    {partnerMappingFields.valueChainPartner.map(
                      (item, index) => (
                        <span
                          key={index}
                          className="bg-gray-100 px-2 py-1 w-fit rounded text-sm text-gray-800"
                        >
                          {item.label}
                        </span>
                      )
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PartnerMappingPopup;
